/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerListItemsQueryResponse, TrimbleItemsControllerListItemsQueryParams } from "../../models/trimbleController/TrimbleItemsControllerListItems";

function getTrimbleItemsControllerListItemsUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble/items` as const }  
  return res
}

/**
 * @summary Browse Trimble sources, projects and folders
 * {@link /api/v1/trimble/items}
 */
export async function trimbleItemsControllerListItems(params: TrimbleItemsControllerListItemsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleItemsControllerListItemsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getTrimbleItemsControllerListItemsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}